import { LoadingButton } from "@mui/lab";
import { Grid } from "@mui/material";
import { useEndCustomerPaid } from "Context/EndCustomerPaid";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import { useState } from "react";

const BookButton = () => {
  const {
    confirmMatches,
    createPaidInvoices,
    selectedBundleId,
    totalAmountLeft,
    totalNrInvoices,
    coinRounding,
  } = useEndCustomerPaid();
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const { openError, openSuccess } = usePopupNotificationContext();

  const handleConfirmMatches = async () => {
    setLoadingConfirm(true);
    const res = await confirmMatches();
    if (res.status === 201) {
      openSuccess(`${res.data.Message}`, 3000);
    } else {
      openError("Ett fel har uppstått", 5000);
    }
    setLoadingConfirm(false);
  };

  const createAllFiles = async () => {
    setLoadingCreate(true);
    const res = await createPaidInvoices();
    if (res && res.status === 201) {
      openSuccess(res.data.Message ? res.data.Message : "OK", 3000);
    } else {
      openError("Någonting gick fel", 3000);
    }
    setLoadingCreate(false);
  };

  const handleCoinRounding = async () => {
    setLoadingCreate(true);

    const res = await coinRounding();

    if (res.status === 201) {
      openSuccess(res.data.Message ? res.data.Message : "OK", 3000);
      await createPaidInvoices();
    } else {
      openError(res.data.Message ? res.data.Message : "Error", 5000);
    }

    setLoadingCreate(false);
  };

  return (
    <>
      <Grid
        container
        item
        xs={12}
        md={12}
        justifyContent="space-between"
        marginTop="10px"
      >
        <LoadingButton
          onClick={() => createAllFiles()}
          loading={loadingCreate}
          disabled={selectedBundleId === null}
          variant="contained"
        >
          Uppdatera
        </LoadingButton>
        <div>
          <LoadingButton
            sx={{ marginRight: 2 }}
            onClick={() => handleCoinRounding()}
            loading={loadingCreate}
            variant="contained"
          >
            Öresavrundning
          </LoadingButton>
          <LoadingButton
            loading={loadingConfirm}
            onClick={() => handleConfirmMatches()}
            variant="contained"
            disabled={totalAmountLeft !== 0 || totalNrInvoices === 0}
          >
            Bokför
          </LoadingButton>
        </div>
      </Grid>
    </>
  );
};

export default BookButton;
